import React, { Component } from 'react';
import { Card, CardTitle, CardText, Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

class Users extends Component {
    render() {
    const { profile, auth } = this.props;
    if (!auth.uid) return <Redirect to='/' />
    return (
        <div className="Account container">
          <Card body style={{backgroundColor:"#00D1B2", borderWidth: "0px"}}>
            <CardTitle><h1 className="text-center display-4">Personal Stats</h1></CardTitle>
            <CardText className="text-center lead">{profile.firstName} {profile.lastName}</CardText>
            <br/>
            <Row>
              <Col className="text-center">
                <i class="fas fa-trash fa-3x"></i>
                <CardText><h1 className="text-center">{profile.trashCount}</h1></CardText>
              </Col>
              <Col className="text-center">
                <i class="fas fa-recycle fa-3x"></i>
                <CardText><h1 className="text-center">{profile.recycleCount}</h1></CardText>
              </Col>
             
            </Row>
          </Card>
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      auth: state.firebase.auth,
      profile: state.firebase.profile
  }
}

export default connect(mapStateToProps)(Users)